import { useRouter } from 'next/router';
import BaseColor from '@/atoms/colors/Base';
import PrimaryNavigationBar from '@/organisms/navigation/PrimaryNavigationBar/PrimaryNavigationBar';
import { EntityHierarchyProvider, DesignsProvider } from '@/shared/providers';
import AppErrorBoundary from '@/components/AppErrorBoundary/AppErrorBoundary';
import restrictNavigation from './utils/restrictNavigation';

const AppLayout = ({ children, skipProviders }) => {
  const router = useRouter();
  const current = router.asPath;
  const showNavigation = !restrictNavigation(current);

  if (skipProviders) {
    return (
      <div
        style={{
          backgroundColor: BaseColor.background.secondary,
          height: showNavigation ? 'calc(100vh - 45px)' : 'calc(100vh)',
          width: '100%',
          overflow: 'hidden',
        }}
      >
        {children}
      </div>
    );
  }

  return (
    <DesignsProvider>
      <div style={{ width: '100%' }}>
        {showNavigation && (
          <EntityHierarchyProvider>
            <PrimaryNavigationBar />
          </EntityHierarchyProvider>
        )}
        <div
          style={{
            backgroundColor: BaseColor.background.secondary,
            height: showNavigation ? 'calc(100vh - 45px)' : 'calc(100vh)',
            width: '100%',
            overflow: 'hidden',
          }}
        >
          <AppErrorBoundary>{children}</AppErrorBoundary>
        </div>
      </div>
    </DesignsProvider>
  );
};

export default AppLayout;
